import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Attribute } from '@emm/core/models/attribute.model';
import {TagService} from '@emm/core/services/tag.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';

@Component({
    selector: 'emm-edit-consumer-attributes-dialog',
    styleUrls: ['./edit-consumer-attributes-dialog.component.scss'],
    templateUrl: './edit-consumer-attributes-dialog.component.html',
    standalone: false
})
export class EditConsumerAttributesDialogComponent implements OnInit {
    form: FormGroup;

    assignedAttributes: Attribute[] = [];
    unassignedAttributes: Attribute[] = [];

    initialAssignedAttributes: Attribute[] = [];
    initialUnassignedAttributes: Attribute[] = [];

    selectedAttribute?: Attribute;

    constructor(
        public dialogRef: MatDialogRef<EditConsumerAttributesDialogComponent>,
        public tagService: TagService,
        public managementApiService: ManagementApiService,
        @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '250px' });

        this.assignedAttributes = [].concat(this.data.assignedAttributes);
        this.unassignedAttributes = [].concat(this.data.unassignedAttributes);

        this.initialAssignedAttributes = [].concat(this.assignedAttributes);
        this.initialUnassignedAttributes = [].concat(this.unassignedAttributes);
    }

    closeAfterSubmit(): void {

        const result = {
                assignedAttributes: this.assignedAttributes,
                unassignedAttributes: this.unassignedAttributes,
                changesMade: this.changesMade()
            };

        this.dialogRef.close(result);
    }

    onCancel(): void {

        this.assignedAttributes = [];
        this.unassignedAttributes = [];

        this.dialogRef.close();
    }

    onSubmit(): void {
        this.closeAfterSubmit();
    }

    onSelect(attribute){
        this.selectedAttribute = attribute;
    }

    dropAttribute(event: CdkDragDrop<any>){

        if (event.previousContainer !== event.container){
            transferArrayItem(event.previousContainer.data, event.container.data,
                event.previousIndex, event.currentIndex);
        } else {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }

        this.selectedAttribute = event.container.data[event.currentIndex];

    }

    changesMade(): boolean {
        const unassignedAttributesSame =
            this.unassignedAttributes.filter(ua => this.initialUnassignedAttributes.some(iua => ua.tag === iua.tag));

        if (unassignedAttributesSame.length === this.unassignedAttributes.length &&
                this.unassignedAttributes.length === this.initialUnassignedAttributes.length){
                    return false;
        }
        else{
            return true;
        }
    }
}
